import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ASYNC_STATUS, isLoading } from '@scripts/utilities/redux-helpers.js';
import RestClient from '@scripts/utilities/rest-client.js';


const initialState = {
  status: ASYNC_STATUS.IDLE,
  /**
   * A list of assets
   */
  assets: []
};


var fetchThunk = createAsyncThunk('assets/fetch', function() {
  return RestClient.get('/wp-json/sbm/v1/assets/');
});



const assetsSlice = createSlice({
    name: 'assets',
    initialState: initialState,
    reducers: { },
    extraReducers: function(builder) {
      builder
        .addCase(fetchThunk.pending, function(state) {
          state.status = ASYNC_STATUS.INPROGRESS;
        })
        .addCase(fetchThunk.fulfilled, function(state, action) {
          state.status = ASYNC_STATUS.COMPLETE;
          state.assets = action.payload;
        });
    }
});


/**
 * helper function for retrieving the assets from the store
 */
export function getAssetState(state) {
  return state.assets;
}
export function isAssetsLoading(state) {
  return isLoading(getAssetState(state).status);
}
/**
 * Return all assets, including assets which have been automatically generated.
 */
export function getAllAssets(state) {
  return getAssetState(state).assets;
}
/**
 * Return only reviewed assets. i.e. only those assets that have been reviewed by
 * Collective Shift.
 */
export function getReviewedAssets(state) {
  var assets = getAllAssets(state);
  var result = [];

  for (var i = 0; i < assets.length; i++) {
    if (assets[i].reviewed) {
      result.push(assets[i]);
    }
  }

  return result;
}

/**
 * return only Rated assets. i.e. only those assets that have a bullish or bearish indicator
 * Collective Shift.
 */
export function getRatedAssets(state) {
  var assets = getAllAssets(state);
  var result = [];

  for (var i = 0; i < assets.length; i++) {
    if (assets[i].indicator) {
      result.push(assets[i]);
    }
  }

  return result;
}

export function getAssetById(state, id) {
  var result = null;
  var assets = getAllAssets(state);

  if (assets.length) {
    for (var i = 0; i < assets.length; i++) {
      if (assets[i].id == id) {
        result = assets[i];
        break;
      }
    }
  }


  return result;
}


/**
 * Action creators
 */
export var fetch = function() {
  return function(dispatch, getState) {
    var state = getState();
    var assets = getAssetState(state);

    if (assets.status == ASYNC_STATUS.IDLE) {
      dispatch(fetchThunk());
    }
  };
};


export default assetsSlice.reducer;

